import umi from "../../../../assets/images/productos/umi/UMI.png";
import qr from "../../../../assets/images/QR Daniel Montes.svg";
import Producto from "../../../../components/producto";

import pic1 from "../../../../assets/images/productos/umi/Mosaico - UM1.JPG"

import { useTranslation } from "react-i18next";

function UMI() {

  const {t} = useTranslation();

  return (
    <Producto
      fotos={[pic1]}
      datosTabla1={[
        [t("tensionMaximaDeServicio"), "kV", "36"],
        [t("corrienteNominal"), "A", "800"],
        [t("corrienteBreveDuracion"), "kA", "20"],
      ]}
      datosTabla2={[]}
      nombreProducto={"UMI"}
      fotoProducto={umi}
      descripcionProducto={
        t("umi.titulo_descripcion")
      }
      caracteristicas={[
        t("umi.bullet1"),
        t("umi.bullet2"),
        t("umi.bullet3"),
        t("umi.bullet4"),
        t("umi.bullet5")
      ]}
      vendedor={{
        nombre: "Daniel Montes",
        telefono: "+54 9 11 3167-6868",
        mail: "dmontes@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20UMI.pdf'}
      tieneTabla2={false}
    />
  );
}

export default UMI;